import { StyledNavItem, StyledNavItemIcon } from '../nav-section/styles';
import { ListItemText, Tooltip } from '@mui/material';
import ApiIcon from '@mui/icons-material/Api';
import i18n from '../../i18n';

export const NavApi = ({ collapsed }) => {
    return (
        <StyledNavItem
            component="a"
            href="/doc/api-static.html"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
                ml: 1
            }}
        >
            {collapsed ? (
                <Tooltip
                    title={i18n.t('pages.api.title')}
                    placement="right"
                    arrow
                >
                    <StyledNavItemIcon>
                        <ApiIcon />
                    </StyledNavItemIcon>
                </Tooltip>
            ) : (
                <StyledNavItemIcon>
                    <ApiIcon />
                </StyledNavItemIcon>
            )}

            {!collapsed && (
                <ListItemText
                    disableTypography
                    primary={i18n.t('pages.api.title')}
                />
            )}
        </StyledNavItem>
    );
};
